export enum FatigueManagerTabKey {
  LIVE_VIEW = 'fatigue-live-view',
  HISTORIC_VIEW = 'fatigue-historic-view',
}
